/* eslint-disable @babel/development/plugin-name */

export { default } from "@babel/plugin-transform-react-jsx/lib/development";
